import { LandingIcon } from "./LandingIcon";

export function LandingFinalCTA() {
  return (
    <section className="relative z-10 flex flex-col items-center overflow-hidden border-white/[0.06] border-b bg-brand-dark px-6 py-40 text-center md:px-12">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 50% 100%, rgba(255, 255, 255, 0.035) 0%, transparent 55%)",
        }}
      />

      <div className="scroll-fade relative z-10 max-w-2xl">
        <h2 className="js-mask-reveal mb-8 font-medium text-4xl text-white tracking-tight md:text-6xl md:leading-[1]">
          Activá tu hato.
        </h2>
        <p className="mb-12 text-lg text-neutral-400 leading-relaxed">
          Solicitá acceso a HATO. Te configuramos la cuenta con el mapeo a tu plan contable y
          arrancamos con tu finca.
        </p>
        <div className="flex flex-col justify-center gap-4 sm:flex-row">
          <a
            href="/access-request"
            className="group relative flex w-full items-center justify-center gap-3 rounded-full border border-white/[0.06] bg-brand-panel p-1 pr-6 transition-colors hover:border-primary-500/50 sm:w-auto"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-full border border-primary-500/30 bg-primary-500/10 text-primary-500 transition-colors group-hover:bg-primary-500 group-hover:text-brand-dark">
              <LandingIcon name="arrow-right" size={20} />
            </span>
            <span className="font-medium text-sm text-white">Solicitar acceso</span>
          </a>
          <a
            href="#method"
            className="flex h-14 w-full items-center justify-center rounded-full border border-white/[0.1] px-8 font-medium text-sm text-white transition-colors hover:bg-white/[0.05] sm:w-auto"
          >
            Conocé más
          </a>
        </div>
      </div>
    </section>
  );
}
